export default __webpack_public_path__ + "static/media/file16.25f722cd.jpg";